import React from 'react';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { HOST_MEETING_TEXT, JOIN_AS_ATTENDEE } from '../../../_connections/connections.texts';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';


export const WebexConnectionDetailsPopoverContent = (props: BaseConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onLinkClick, onCopyBtnClick } = props;
    const {
        type,
        hostLink,
        cancelled,
        connectionLink,
        connectionId,
        connectionPassword,
        connectionAccount,
        sip,
        connectionHostKey
    } = connection;

    const labels = connectionsDetailsLabels();

    const hostManagementPermission = hasPermission(Permission.HOST_MANAGEMENT);

    return (
        <>
            <div className='connection-list__header'>
                {hostManagementPermission && <DefaultButton
                    className='prominent-button'
                    disabled={!hostLink || cancelled}
                    text={<FormattedMessage {...HOST_MEETING_TEXT} />}
                    onClick={() => onLinkClick(hostLink)}
                />}
                <DefaultButton
                    className='small-button silver-button'
                    disabled={!connectionLink || cancelled}
                    text={<FormattedMessage {...JOIN_AS_ATTENDEE} />}
                    onClick={() => onLinkClick(connectionLink)}
                />
            </div>
            <div className='connection-list__field'>{type} {labels.MEETING_ID()}:<br />
                <TextWithCopyBtn message={connectionId} handleCopyClick={onCopyBtnClick} />
            </div>
            {connectionPassword && <div className='connection-list__field'>{type} {labels.MEETING_PASSCODE()}:<br />
                <TextWithCopyBtn message={connectionPassword} handleCopyClick={onCopyBtnClick} />
            </div>}
            {sip && <div className='connection-list__field'>{type} {labels.SIP()}:<br />
                <TextWithCopyBtn message={sip} handleCopyClick={onCopyBtnClick} />
            </div>}
            {connectionAccount && <div className='connection-list__field'>{type} {labels.ACCOUNT()}:<br />
                <TextWithCopyBtn message={connectionAccount} handleCopyClick={onCopyBtnClick} />
            </div>}
            {connectionHostKey &&
                <div className='connection-list__field'>{type} {labels.HOST_KEY()}:<br />
                    <TextWithCopyBtn message={connectionHostKey} handleCopyClick={onCopyBtnClick} />
                </div>
            }
            {connectionLink && <div className='connection-list__field'>{type} {labels.LINK()}:<br />
                <TextWithCopyBtn message={connectionLink} handleCopyClick={onCopyBtnClick} />
            </div>}
        </>
    );
};
